export const videoButton = () => {
  $('video').each(function () {
    $(this).closest('.wp-block-media-text').addClass('has-video');
  });

  $('figcaption').each(function () {
    $(this).closest('.wp-block-video').addClass('has-caption');
  });

  $(document).on('click', 'video', function () {
    if (this.paused) {
      $(this).closest('.wp-block-video, .wp-block-media-text__media').addClass('playing');
    } else {
      $(this).closest('.wp-block-video, .wp-block-media-text__media').removeClass('playing');
    }
  });
};
